import {defineNuxtPlugin} from '#app'
import {gsap} from 'gsap'
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.hook('page:transition:finish', () => {
		const ss = gsap.ScrollSmoother?.get()
		if (ss) {
			ss.scrollTo(0)
		} else {
			gsap.to(window, {scrollTo: 0, duration: 0.3})
		}
	})
})
